






























import { InputPolicy, MaxBiteFilter } from "@/common/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QErrors from "../../common/qErrors.vue";
import YubinBangoCore from "../../common/scripts/yubinbango-core";

@Component({
  name: "PostalCode",
  components: {
    QErrors,
  },
})
export default class PostalCode extends Vue {
  @Prop()
  public errors: any;
  @Prop()
  public value: string;
  @Prop()
  public errorKey: string;
  @Prop({
    default: 7,
  })
  public max: number;
  @Prop({ default: "mb__button" })
  public classes: string;
  @Prop({
    default: () => {
      return {
        width: "inherit",
        marginBottom: "1rem",
        marginTop: "0rem",
      };
    },
  })
  public errorStyle: string;
  public isNotFound: boolean = false;
  public isLoading = false;

  public fullWidthNumConvert(fullWidthNumber) {
    return fullWidthNumber.replace(/[\uFF10-\uFF19]/g, function(m) {
      return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
    });
  }

  public mounted() {
    this.isNotFound = false;
  }

  public search() {
    this.isLoading = true;
    this.isNotFound = false;
    try {
      new YubinBangoCore(
        this.fullWidthNumConvert(this.value),
        function(addr) {
          if (addr.region) {
            this.$emit("result", {
              pref_name: addr.region,
              city_name: `${addr.locality}${addr.street}`,
              address: addr.extended,
              prefecture_code: addr.region_id,
            });
          } else {
            this.isNotFound = true;
          }
        }.bind(this),
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  public handleChange(event) {
    const updated = this.replaceInput(event.target.value);
    event.target.value = updated;
    this.$emit("input", updated);
  }

  public replaceInput(input: string) {
    const checked = InputPolicy.check(input, "Number");
    return MaxBiteFilter(checked, this.max);
  }
}
